import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Chat from "./Chat";
import LoginPage from "./Login";
import ChatV2 from "./ChatV2";
import Trials from "./Trials";
import SwitchChatDropdown from "./SwitchChatDropdown";
import Drugs from "./Drugs";
import AgentOwl from "./AgentOwl";


function withDropdown(Component) {
  return function WrappedComponent(props) {
    return (
      <div style={{ position: 'relative' }}>
        <SwitchChatDropdown />
        <Component {...props} />
      </div>
    );
  };
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/chat" element={withDropdown(Chat)()} />
        <Route path="/trials" element={withDropdown(Trials)()} />
        <Route path="/agent-owl" element={withDropdown(AgentOwl)()} />
        <Route path="/chat/v2" element={<ChatV2 />} />
        <Route path="/drugs" element={withDropdown(Drugs)()} />
      </Routes>
    </Router>
  );
}

export default App;
